<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 <i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos" class="">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-danger mr-2"></span> Turno 2 <i class="mr-2"></i>
            <small class="">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <span v-if="auth.puedeCambiarEstadoFinalizado == true">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2" v-b-tooltip.left title="Presione para desbloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-lock"></i>Finalizado</a>
            <a href="#" v-if="finalizado == false" class="btn btn-sm btn-light font-weight-bold mr-2" v-b-tooltip.left title="Presione para bloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-unlock-alt"></i>Desbloquear</a>
          </span>
          <span v-if="auth.puedeCambiarEstadoFinalizado == false">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2"> <i class="fa fa-lock"></i>Finalizado</a>
          </span>

          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>

          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body" v-show="expandirContenido">
        <form class="form" id="frm-turno-2">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-8">

              <!-- I. Presencia -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">I. Presencia</h3>
                <div class="form-group row">
                  <label :class="ui.colLeftClass">Hay presencia de:</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group mb-2" role="group">
                      <button type="button" @click.prevent="actual.t2PresenciaOnpe = !actual.t2PresenciaOnpe" class="btn" :class="[actual.t2PresenciaOnpe ? 'btn-primary' : 'btn-outline-secondary']">ONPE</button>
                      <button type="button" @click.prevent="actual.t2PresenciaJne = !actual.t2PresenciaJne" class="btn" :class="[actual.t2PresenciaJne ? 'btn-primary' : 'btn-outline-secondary']">JNE</button>
                      <button type="button" @click.prevent="actual.t2PresenciaFfaapnp = !actual.t2PresenciaFfaapnp" class="btn" :class="[actual.t2PresenciaFfaapnp ? 'btn-primary' : 'btn-outline-secondary']">FFAA / PNP</button>
                      <button type="button" @click.prevent="actual.t2PresenciaMinisterioPublico = !actual.t2PresenciaMinisterioPublico" class="btn" :class="[actual.t2PresenciaMinisterioPublico ? 'btn-primary' : 'btn-outline-secondary']">Ministerio Público</button>
                      <button type="button" @click.prevent="actual.t2PresenciaDefensoriaDelPueblo = !actual.t2PresenciaDefensoriaDelPueblo" class="btn" :class="[actual.t2PresenciaDefensoriaDelPueblo ? 'btn-primary' : 'btn-outline-secondary']">Defensoría del pueblo</button>
                    </div>
                    <div class="btn-group btn-group mb-2" role="group">
                      <button type="button" @click.prevent="actual.t2PresenciaOtros = !actual.t2PresenciaOtros" class="btn" :class="[actual.t2PresenciaOtros ? 'btn-primary' : 'btn-outline-secondary']">Otros</button>
                    </div>
                    <textarea v-if="actual.t2PresenciaOtros" v-model="actual.t2PresenciaOtrosDetalle" class="form-control mt-2" type="text" placeholder="Indicar el nombre de la entidad..."></textarea>
                  </div>
                </div>
              </div>

              <!-- II. SEGUIMIENTO A LA VOTACIÓN -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">II. Seguimiento a la votación</h3>

                <!-- 2.6 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.6. ¿El local de votación está debidamente señalizado y cuenta con mecanismos que permitan la identificación y ubicación de la mesa de votación, así como de los accesos y salidas?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2LocalDebidamenteSenializadoYUbicacionMesas = true" class="btn" :class="[actual.t2LocalDebidamenteSenializadoYUbicacionMesas === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2LocalDebidamenteSenializadoYUbicacionMesas = false" class="btn" :class="[actual.t2LocalDebidamenteSenializadoYUbicacionMesas === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2LocalDebidamenteSenializadoYUbicacionMesas === false" v-model="actual.t2LocalDebidamenteSenializadoYUbicacionMesasDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente por qué:..." required></textarea>
                  </div>
                </div>

                <!-- 2.7 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.7. ¿Existen mecanismos de acceso al local de votación para personas con discapacidad, mujeres embarazadas y adultos mayores?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2LocalAccesiblePersonasPrioritarias = true" class="btn" :class="[actual.t2LocalAccesiblePersonasPrioritarias === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2LocalAccesiblePersonasPrioritarias = false" class="btn" :class="[actual.t2LocalAccesiblePersonasPrioritarias === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2LocalAccesiblePersonasPrioritarias === false" v-model="actual.t2LocalAccesiblePersonasPrioritariasDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente por qué:..." required></textarea>
                  </div>
                </div>

                <!-- 2.8 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.8. En el local de votación, ¿se ha habilitado un área de SUFRAGIO en el primer piso para personas con discapacidad o adultos mayores?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2AreaSufragioPrimerPiso = true" class="btn" :class="[actual.t2AreaSufragioPrimerPiso === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2AreaSufragioPrimerPiso = false" class="btn" :class="[actual.t2AreaSufragioPrimerPiso === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2AreaSufragioPrimerPiso === false" v-model="actual.t2AreaSufragioPrimerPisoDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente por qué:..." required></textarea>
                  </div>
                </div>
              </div>

              <!-- III. PARTICIPACIÓN DE ORGANIZACIONES POLÍTICAS Y DE OBSERVADORES ELECTORALES -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">III. Participación de organizaciones políticas y de observadores electorales</h3>

                <!-- 3.1 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.1. ¿Hay presencia de personeros en el local de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2HayPersonerosEnLocal = true" class="btn" :class="[actual.t2HayPersonerosEnLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2HayPersonerosEnLocal = false" class="btn" :class="[actual.t2HayPersonerosEnLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2HayPersonerosEnLocal === true" class="mt-2">
                      <label class="mb-1">Número total de personeros:</label>
                      <input type="number" min="0" class="form-control mb-2" v-model="actual.t2HayPersonerosEnLocalCantidad" placeholder="Número total de personeros..." />
                      <label class="mb-1">Personeros registrados/acreditados por organización política:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsPersonerosTurno2" :key="'t2reg-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <!-- <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup> -->
                                </select>
                                <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..." />
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsPersonerosTurno2, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsPersonerosTurno2)"><i class="fa fa-plus"></i> Agregar</a>
                    </div>
                  </div>
                </div>

                <!-- 3.2 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.2. ¿Hay presencia de delegaciones de observadores internacionales?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2HayObservadoresInternacionales = true" class="btn" :class="[actual.t2HayObservadoresInternacionales === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2HayObservadoresInternacionales = false" class="btn" :class="[actual.t2HayObservadoresInternacionales === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2HayObservadoresInternacionales === true" v-model="actual.t2HayObservadoresInternacionalesDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle..." required></textarea>
                  </div>
                </div>

                <!-- 3.3 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.3. ¿Hay presencia de otras delegaciones de observación nacional?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2HayObservacionNacional = true" class="btn" :class="[actual.t2HayObservacionNacional === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2HayObservacionNacional = false" class="btn" :class="[actual.t2HayObservacionNacional === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2HayObservacionNacional === true" v-model="actual.t2HayObservacionNacionalDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle..." required></textarea>
                  </div>
                </div>
              </div>

              <!-- IV. INCIDENCIAS -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">IV. Incidencias</h3>

                <!-- 4.1 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.1. ¿Se observó dentro del local de votación algún acto de intimidación o violencia que impida el ejercicio del voto ciudadano?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2ActoIntimidacionOViolencia = true" class="btn" :class="[actual.t2ActoIntimidacionOViolencia === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2ActoIntimidacionOViolencia = false" class="btn" :class="[actual.t2ActoIntimidacionOViolencia === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2ActoIntimidacionOViolencia === true" v-model="actual.t2ActoIntimidacionOViolenciaDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle..." required></textarea>
                  </div>
                </div>

                <!-- 4.2 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.2. ¿Se produjo alguna acción que impida tu labor como observador/a electoral?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2AccionImpideLaborObservador = true" class="btn" :class="[actual.t2AccionImpideLaborObservador === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2AccionImpideLaborObservador = false" class="btn" :class="[actual.t2AccionImpideLaborObservador === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t2AccionImpideLaborObservador === true" v-model="actual.t2AccionImpideLaborObservadorDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle..." required></textarea>
                  </div>
                </div>

                <!-- 4.3 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.3. ¿Se reportó el abandono de miembros de mesa?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2ReporteAbandonoMiembroMesaLocal = true" class="btn" :class="[actual.t2ReporteAbandonoMiembroMesaLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2ReporteAbandonoMiembroMesaLocal = false" class="btn" :class="[actual.t2ReporteAbandonoMiembroMesaLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2ReporteAbandonoMiembroMesaLocal === true" class="mt-2">
                      <textarea v-model="actual.t2ReporteAbandonoMiembroMesaLocalDetalle" class="form-control mb-2" type="text" placeholder="Indique detalle..." required></textarea>
                      <input type="text" class="form-control" v-model="actual.t2ReporteAbandonoMiembroMesaLocalNroMesa" placeholder="N.° de mesa..." />
                    </div>
                  </div>
                </div>

                <!-- 4.4 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.4. ¿Se observaron altercados entre personeros de organizaciones políticas?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2AltercadosEntrePersoneros = true" class="btn" :class="[actual.t2AltercadosEntrePersoneros === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2AltercadosEntrePersoneros = false" class="btn" :class="[actual.t2AltercadosEntrePersoneros === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2AltercadosEntrePersoneros === true" class="mt-2">
                      <label class="mb-1">Organizaciones políticas involucradas:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsT2AltercadosEntrePersoneros" :key="'t2alt-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <!-- <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mra-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup> -->
                                </select>
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsT2AltercadosEntrePersoneros, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsT2AltercadosEntrePersoneros)"><i class="fa fa-plus"></i> Agregar</a>
                      <textarea v-model="actual.t2AltercadosEntrePersonerosDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle..." required></textarea>
                    </div>
                  </div>
                </div>

                <!-- 4.5 -->
                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.5. ¿Observaste personas con elementos (ropa, gorros, pines, carteles o similares) a favor de alguna organización política dentro del local de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t2PersonasConElementosPropagandaDentroLocal = true" class="btn" :class="[actual.t2PersonasConElementosPropagandaDentroLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t2PersonasConElementosPropagandaDentroLocal = false" class="btn" :class="[actual.t2PersonasConElementosPropagandaDentroLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t2PersonasConElementosPropagandaDentroLocal === true" class="mt-2">
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsPropagandaTurno2" :key="'t2prop-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <!-- <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mrp-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup> -->
                                </select>
                                <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..." />
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsPropagandaTurno2, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsPropagandaTurno2)"><i class="fa fa-plus"></i> Agregar</a>
                      <textarea v-model="actual.t2PersonasConElementosPropagandaDentroLocalDetalle" class="form-control mt-2" type="text" placeholder="Indique detalle adicional..." rows="2"></textarea>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-xl-2"></div>

            <div v-if="eventosActualizacion.length > 0" v-html="eventosActualizacion"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}
</style>

<script>
export default {
  name: "ficha-turno-2-local",
  components: {},
  props: {
    localVotacionId: {
      type: Number,
    },
    procesoElectoralId: {
      type: Number,
    },
    expandirContenido: {
      type: Boolean,
    },
    intervaloAutoGuardado: {
      type: Number,
    },
  },
  data: () => ({
    finalizado: false,
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      puedeCambiarEstadoFinalizado: null,
      puedeEditarTurno: null,
      puedeVisualizarTurno: null,
      puedeFinalizarTurno: null,
      puedeReanudarTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
      fechaInicioEdicionTurno: null,
      fechaFinEdicionTurno: null,
    },
    ui: {
      colLeftClass: "col-sm-12 col-md-5",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    eventosActualizacion: [],
    actual: {
      t2PresenciaOnpe: null,
      t2PresenciaJne: null,
      t2PresenciaFfaapnp: null,
      t2PresenciaMinisterioPublico: null,
      t2PresenciaDefensoriaDelPueblo: null,
      t2PresenciaOtros: null,
      t2PresenciaOtrosDetalle: null,
      t2LocalDebidamenteSenializadoYUbicacionMesas: null,
      t2LocalDebidamenteSenializadoYUbicacionMesasDetalle: null,
      t2LocalAccesiblePersonasPrioritarias: null,
      t2LocalAccesiblePersonasPrioritariasDetalle: null,
      t2AreaSufragioPrimerPiso: null,
      t2AreaSufragioPrimerPisoDetalle: null,
      t2HayPersonerosEnLocal: null,
      t2HayPersonerosEnLocalCantidad: null,
      itemsPersonerosTurno2: [],
      t2AltercadosEntrePersonerosOrganizacionParamId: null,
      itemsT2AltercadosEntrePersoneros: [],
      t2HayObservadoresInternacionales: null,
      t2HayObservadoresInternacionalesDetalle: null,
      t2HayObservacionNacional: null,
      t2HayObservacionNacionalDetalle: null,
      t2ActoIntimidacionOViolencia: null,
      t2ActoIntimidacionOViolenciaDetalle: null,
      t2AccionImpideLaborObservador: null,
      t2AccionImpideLaborObservadorDetalle: null,
      t2ReporteAbandonoMiembroMesaLocal: null,
      t2ReporteAbandonoMiembroMesaLocalDetalle: null,
      t2ReporteAbandonoMiembroMesaLocalNroMesa: null,
      t2AltercadosEntrePersoneros: null,
      t2AltercadosEntrePersonerosDetalle: null,
      t2PersonasConElementosPropagandaDentroLocal: null,
      t2PersonasConElementosPropagandaDentroLocalDetalle: null,
      itemsPropagandaTurno2: [],
    },
    partidos: [],
    guardado: {
      t2PresenciaOnpe: null,
      t2PresenciaJne: null,
      t2PresenciaFfaapnp: null,
      t2PresenciaMinisterioPublico: null,
      t2PresenciaDefensoriaDelPueblo: null,
      t2PresenciaOtros: null,
      t2PresenciaOtrosDetalle: null,
      t2LocalDebidamenteSenializadoYUbicacionMesas: null,
      t2LocalDebidamenteSenializadoYUbicacionMesasDetalle: null,
      t2LocalAccesiblePersonasPrioritarias: null,
      t2LocalAccesiblePersonasPrioritariasDetalle: null,
      t2AreaSufragioPrimerPiso: null,
      t2AreaSufragioPrimerPisoDetalle: null,
      t2HayPersonerosEnLocal: null,
      t2HayPersonerosEnLocalCantidad: null,
      itemsPersonerosTurno2: [],
      t2AltercadosEntrePersonerosOrganizacionParamId: null,
      itemsT2AltercadosEntrePersoneros: [],
      t2HayObservadoresInternacionales: null,
      t2HayObservadoresInternacionalesDetalle: null,
      t2HayObservacionNacional: null,
      t2HayObservacionNacionalDetalle: null,
      t2ActoIntimidacionOViolencia: null,
      t2ActoIntimidacionOViolenciaDetalle: null,
      t2AccionImpideLaborObservador: null,
      t2AccionImpideLaborObservadorDetalle: null,
      t2ReporteAbandonoMiembroMesaLocal: null,
      t2ReporteAbandonoMiembroMesaLocalDetalle: null,
      t2ReporteAbandonoMiembroMesaLocalNroMesa: null,
      t2AltercadosEntrePersoneros: null,
      t2AltercadosEntrePersonerosDetalle: null,
      t2PersonasConElementosPropagandaDentroLocal: null,
      t2PersonasConElementosPropagandaDentroLocalDetalle: null,
      itemsPropagandaTurno2: [],
    },
  }),
  computed: {
    partidosNacionales: function() { return (this.partidos || []).filter(function(p) { return p.regionId == 0; }); },
    partidosRegionales: function() { return (this.partidos || []).filter(function(p) { return p.regionId != 0; }); },
    isDirty: function() {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha: function() {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;

      return true;
    },
  },
  methods: {
    inicializarGuardado: function() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos) return;
      if (!this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function() {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) {
          vm.doGuardado(true);
        }
      }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function() {
      this.ui.estaCargandoDatos = true;
      var model = {
        localVotacionId: this.localVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaTurnoDos"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;

          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          tempActual.t2PresenciaOnpe = this.actualizarBaseDiferente("t2PresenciaOnpe", tempActual, tempGuardado, ficha);
          tempActual.t2PresenciaJne = this.actualizarBaseDiferente("t2PresenciaJne", tempActual, tempGuardado, ficha);
          tempActual.t2PresenciaFfaapnp = this.actualizarBaseDiferente("t2PresenciaFfaapnp", tempActual, tempGuardado, ficha);
          tempActual.t2PresenciaMinisterioPublico = this.actualizarBaseDiferente("t2PresenciaMinisterioPublico", tempActual, tempGuardado, ficha);
          tempActual.t2PresenciaDefensoriaDelPueblo = this.actualizarBaseDiferente("t2PresenciaDefensoriaDelPueblo", tempActual, tempGuardado, ficha);
          tempActual.t2PresenciaOtros = this.actualizarBaseDiferente("t2PresenciaOtros", tempActual, tempGuardado, ficha);
          tempActual.t2PresenciaOtrosDetalle = this.actualizarBaseDiferente("t2PresenciaOtrosDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2LocalDebidamenteSenializadoYUbicacionMesas = this.actualizarBaseDiferente("t2LocalDebidamenteSenializadoYUbicacionMesas", tempActual, tempGuardado, ficha);
          tempActual.t2LocalDebidamenteSenializadoYUbicacionMesasDetalle = this.actualizarBaseDiferente("t2LocalDebidamenteSenializadoYUbicacionMesasDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2LocalAccesiblePersonasPrioritarias = this.actualizarBaseDiferente("t2LocalAccesiblePersonasPrioritarias", tempActual, tempGuardado, ficha);
          tempActual.t2LocalAccesiblePersonasPrioritariasDetalle = this.actualizarBaseDiferente("t2LocalAccesiblePersonasPrioritariasDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2AreaSufragioPrimerPiso = this.actualizarBaseDiferente("t2AreaSufragioPrimerPiso", tempActual, tempGuardado, ficha);
          tempActual.t2AreaSufragioPrimerPisoDetalle = this.actualizarBaseDiferente("t2AreaSufragioPrimerPisoDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2HayPersonerosEnLocal = this.actualizarBaseDiferente("t2HayPersonerosEnLocal", tempActual, tempGuardado, ficha);
          tempActual.t2HayPersonerosEnLocalCantidad = this.actualizarBaseDiferente("t2HayPersonerosEnLocalCantidad", tempActual, tempGuardado, ficha);
          tempActual.itemsPersonerosTurno2 = (ficha.itemsPersonerosTurno2 || []).map(function(x) { return { localVotacionFichaPersoneroId: x.localVotacionFichaPersoneroId, organizacionPoliticaParamId: x.organizacionPoliticaParamId, numero: x.numero }; });
          tempActual.t2AltercadosEntrePersonerosOrganizacionParamId = this.actualizarBaseDiferente("t2AltercadosEntrePersonerosOrganizacionParamId", tempActual, tempGuardado, ficha);
          tempActual.itemsT2AltercadosEntrePersoneros = this.actualizarBaseDiferente("itemsT2AltercadosEntrePersoneros", tempActual, tempGuardado, ficha);
          if (!tempActual.itemsT2AltercadosEntrePersoneros || !Array.isArray(tempActual.itemsT2AltercadosEntrePersoneros)) tempActual.itemsT2AltercadosEntrePersoneros = [];
          tempActual.t2HayObservadoresInternacionales = this.actualizarBaseDiferente("t2HayObservadoresInternacionales", tempActual, tempGuardado, ficha);
          tempActual.t2HayObservadoresInternacionalesDetalle = this.actualizarBaseDiferente("t2HayObservadoresInternacionalesDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2HayObservacionNacional = this.actualizarBaseDiferente("t2HayObservacionNacional", tempActual, tempGuardado, ficha);
          tempActual.t2HayObservacionNacionalDetalle = this.actualizarBaseDiferente("t2HayObservacionNacionalDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2ActoIntimidacionOViolencia = this.actualizarBaseDiferente("t2ActoIntimidacionOViolencia", tempActual, tempGuardado, ficha);
          tempActual.t2ActoIntimidacionOViolenciaDetalle = this.actualizarBaseDiferente("t2ActoIntimidacionOViolenciaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2AccionImpideLaborObservador = this.actualizarBaseDiferente("t2AccionImpideLaborObservador", tempActual, tempGuardado, ficha);
          tempActual.t2AccionImpideLaborObservadorDetalle = this.actualizarBaseDiferente("t2AccionImpideLaborObservadorDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2ReporteAbandonoMiembroMesaLocal = this.actualizarBaseDiferente("t2ReporteAbandonoMiembroMesaLocal", tempActual, tempGuardado, ficha);
          tempActual.t2ReporteAbandonoMiembroMesaLocalDetalle = this.actualizarBaseDiferente("t2ReporteAbandonoMiembroMesaLocalDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2ReporteAbandonoMiembroMesaLocalNroMesa = this.actualizarBaseDiferente("t2ReporteAbandonoMiembroMesaLocalNroMesa", tempActual, tempGuardado, ficha);
          tempActual.t2AltercadosEntrePersoneros = this.actualizarBaseDiferente("t2AltercadosEntrePersoneros", tempActual, tempGuardado, ficha);
          tempActual.t2AltercadosEntrePersonerosDetalle = this.actualizarBaseDiferente("t2AltercadosEntrePersonerosDetalle", tempActual, tempGuardado, ficha);
          tempActual.t2PersonasConElementosPropagandaDentroLocal = this.actualizarBaseDiferente("t2PersonasConElementosPropagandaDentroLocal", tempActual, tempGuardado, ficha);
          tempActual.t2PersonasConElementosPropagandaDentroLocalDetalle = this.actualizarBaseDiferente("t2PersonasConElementosPropagandaDentroLocalDetalle", tempActual, tempGuardado, ficha);
          tempActual.itemsPropagandaTurno2 = (ficha.itemsPropagandaTurno2 || []).map(function(x) { return { localVotacionFichaPersoneroId: x.localVotacionFichaPersoneroId, organizacionPoliticaParamId: x.organizacionPoliticaParamId, numero: x.numero }; });

          this.actual = this.cloneObject(tempActual);
          // Copia del estado ya normalizado (no del JSON de `ficha`), para que isDirty coincida con lo mostrado
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    actualizarBaseDiferente: function(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var valorActual = JSON.stringify(fichaActual[propiedad]);
      var valorGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var valorActualizado = JSON.stringify(fichaActualizada[propiedad]);

      if (valorActual == valorGuardado && valorGuardado != valorActualizado) {
        return fichaActualizada[propiedad];
      } else {
        return fichaActual[propiedad];
      }
    },
    doGuardado: async function(omitirNotificacion) {
      if (this.ui.estaGuardando) return;

      if (!this.isFormValid("frm-turno-2")) {
        if (omitirNotificacion != true) {
          this.$bvToast.toast("Hay campos con valores incorrectos. Revise los datos ingresados.", {
            title: "Turno 2",
            autoHideDelay: 5000,
            variant: "warning",
            appendToast: false,
            solid: true,
          });
        }
        return false;
      }

      var actualClone = this.cloneObject(this.actual);

      var model = this.cloneObject(this.actual);
      model.localVotacionId = this.localVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;

      var guardadoExistoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaTurnoDos"), model).then(function(response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;

          if (omitirNotificacion != true) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 2",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: false,
              solid: true,
            });
          }
          guardadoExistoso = true;

          this.$notifyHub.notificarCambioFicha(this.procesoElectoralId, this.localVotacionId, 2);
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExistoso;
    },
    doToggleFinalizado: async function() {
      if (this.finalizado) {
        if (!(await this.sweetConfirm("¿Desea desbloquear esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      } else {
        if (!(await this.sweetConfirm("¿Desea finalizar esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      }
    },
    fetchPartidosPoliticos: function() {
      var self = this;
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } }).then(function(response) {
        var parameterResponse = response.body && response.body.data ? response.body.data : [];
        self.partidos = parameterResponse;
      });
    },
    addItemPersonero: function(arr) {
      if (!arr) return;
      arr.push({ localVotacionFichaPersoneroId: null, organizacionPoliticaParamId: null, numero: null });
    },
    deleteItemPersonero: function(arr, item) {
      if (!arr) return;
      var idx = arr.indexOf(item);
      if (idx >= 0) arr.splice(idx, 1);
    },
    getImagenPartidoPolitico: function(partidoPoliticoParamId) {
      var partido = this.partidos.find(function(x) { return x.parametroId == partidoPoliticoParamId; });
      var imagen = partido ? partido.imagen : null;
      if (!imagen) imagen = "app-partidos/_no-image.png";
      return this.apiResource(imagen);
    },
  },
  watch: {
    isDirty: function(newValue) {
      if (newValue && this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0) {
        this.inicializarGuardado();
      } else {
        clearTimeout(this.temporizadorGuardado);
      }
    },
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted: function() {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy: function() {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>
